/**
 * @description defines routes to the Personnel Sync Administration pages
 */

import React from 'react';
import { Navigate } from 'react-router-dom';

import ManagePersonnelSync from '@seccon/pages/managePersonnelSync';
import PersonnelSyncHistoryDetails from '@seccon/pages/personnelSyncHistoryDetails';

// Routes for the personnel sync administration pages
export default [
  {
    path: '/managePersonnelSync',
    children: [
      {
        path: 'index',
        element: (
          <Navigate to='history' replace />
        )
      },
      {
        path: 'index/:tabName',
        children: [
          {
            index: true,
            element: (
              <ManagePersonnelSync />
            )
          },
          {
            path: 'details/:historyId',
            element: (
              <PersonnelSyncHistoryDetails />
            )
          }
        ]
      }
    ]
  }
];
